<!--<div class="c-radio-button__selection" *ngIf="isSelected"></div>-->
<div class="c-radio-button__circle"></div>
<div class="c-radio-button__label">
    <ng-content></ng-content>
</div>
